
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/enter/payment",
      function () {
        return require("private-next-pages/enter/payment.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/enter/payment"])
      });
    }
  